module.exports = __webpack_public_path__ + "img/02-bk-city-back-buildings.dd81bbf7.svg";